import { controller, rolesObj } from '../controller'
import { sealStatus } from '../../helpers/constants'
import { localStorageService } from '../../helpers'
import { map, find, isEmpty, filter, pickBy, has } from 'lodash'
export const activityRoles = () => {
  const roles = localStorageService.getUserData()
  const obj = controller().checkRole(roles)
  return {
    checkMultiRole: (activity = true, action = '', page = '') => {
      const { roles } = obj
      const sysRole = find(roles, data => {
        return data.id === rolesObj.systemadmin
      })
      const adminRole = find(roles, data => {
        return data.id === rolesObj.admin
      })
      const purchaserRole = find(roles, data => {
        return data.id === rolesObj.purchaser
      })
      const approverRole = find(roles, data => {
        return data.id === rolesObj.approver
      })
      const tecRole = find(roles, data => {
        return data.id === rolesObj.tec
      })
      const obsRole = find(roles, data => {
        return data.id === rolesObj.observer
      })
      if (page === 'sourcing-project-detail') {
        if (action === 'compare') {
          if (
            sysRole ||
            adminRole ||
            purchaserRole ||
            (approverRole && activity === true) ||
            tecRole ||
            obsRole
          ) {
            return true
          } else {
            return false
          }
        } else if (action === 'history') {
          if (
            sysRole ||
            adminRole ||
            purchaserRole ||
            (approverRole && activity === true) ||
            tecRole ||
            obsRole
          ) {
            return true
          } else {
            return false
          }
        } else if (action === 'edit') {
          if (sysRole || adminRole || purchaserRole || obsRole) {
            return true
          } else {
            return false
          }
        } else if (action === 'copy-rfq') {
          if (sysRole || adminRole || purchaserRole) {
            return true
          } else {
            return false
          }
        } else if (action === 'export') {
          if (sysRole || adminRole || purchaserRole || approverRole) {
            return true
          } else {
            return false
          }
        } else if (action === 'delete') {
          if (sysRole || adminRole || purchaserRole) {
            return true
          } else {
            return false
          }
        }
      } else if (page === 'sourcing-compare-events') {
        if (action === 'reopen') {
          if (sysRole || adminRole || purchaserRole) {
            return true
          } else {
            return false
          }
        }
      }
    },
    getMultiRole: () => {
      const { roles } = obj
      return roles
    },
    checkRolesActions: ({ ...objData }) => {
      const { unsealed } = sealStatus
      const { roles } = obj
      const action = has(objData, 'action')
      const pages = has(objData, 'page')
      if (action && pages) {
        const { page, action } = objData
        if (page === 'sourcing-compare-events') {
          const actions = has(action, 'actions')
          if (actions) {
            const { actions } = action
            const note = filter(actions, value => value === 'note')
            const file = filter(actions, value => value === 'attached')
            const buttonApprove = filter(actions, value => value === 'approve')
            const buttonReject = filter(actions, value => value === 'reject')
            const flowData = filter(
              actions,
              value => value === 'approval_workflow'
            )
            const selections = filter(
              actions,
              value => value === 'selections_roles'
            )
            const buttonCopy = filter(actions, value => value === 'button_copy')
            const buttonExport = filter(
              actions,
              value => value === 'button_export'
            )
            const buttonSubmitAward = filter(
              actions,
              value => value === 'submit_award'
            )
            const buttonSavingTypeClear = filter(
              actions,
              value => value === 'button_saving_type_clear'
            )
            const buttonNoSelection = filter(
              actions,
              value => value === 'button_no_selection'
            )
            const buttonResubmitAward = filter(
              actions,
              value => value === 'button_resubmit_award'
            )
            if (note.length !== 0 && file.length !== 0) {
              const awaitingApprove = has(action, 'awaiting_approve')
              const createby = has(action, 'create_by')
              const approved = has(action, 'approved_status')
              const rejected = has(action, 'rejected')
              const flow = has(action, 'flow_approve')
              const sealType = has(action, 'sealtypeRes')
              const sealStatus = has(action, 'seal_status')
              if (
                awaitingApprove &&
                createby &&
                approved &&
                rejected &&
                flow &&
                sealType &&
                sealStatus
              ) {
                const {
                  awaiting_approve,
                  create_by,
                  approved_status,
                  rejected,
                  flow_approve,
                  sealtypeRes,
                  seal_status,
                } = action
                const buyerId = localStorage.getItem('buyerId')
                const roleSystemadmin = find(roles, data => {
                  return data.id === rolesObj.systemadmin
                })
                const roleAdmin = find(roles, data => {
                  return data.id === rolesObj.admin
                })
                const roleApprover = find(roles, data => {
                  return data.id === rolesObj.approver
                })
                const rolePurchaser = find(roles, data => {
                  return data.id === rolesObj.purchaser
                })
                let arrayRoleAction = []
                if (
                  rolePurchaser ||
                  roleApprover ||
                  roleSystemadmin ||
                  roleAdmin
                ) {
                  if (rolePurchaser) {
                    if (
                      awaiting_approve === 'Awaiting Selection' &&
                      buyerId === create_by
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleSystemadmin) {
                    if (
                      awaiting_approve === 'Awaiting Selection' &&
                      buyerId === create_by
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleAdmin) {
                    if (
                      awaiting_approve === 'Awaiting Selection' &&
                      buyerId === create_by
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleApprover) {
                    if (
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        !sealtypeRes) || // sealtypeRes === false เก่า // ถ้า sealtypeRes เป็น undefined เข้ามาจะไม่แสดงเงื่อนไข
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                } else {
                  const rule = { resRule: false }
                  arrayRoleAction.push(rule)
                }
                const filterRule = filter(
                  arrayRoleAction,
                  value => value.resRule === true
                )
                if (filterRule.length !== 0) {
                  return true
                } else {
                  return false
                }
              }
            } else if (
              buttonApprove.length !== 0 &&
              buttonReject.length !== 0
            ) {
              const awaitingApprove = has(action, 'awaiting_approve')
              const createby = has(action, 'create_by')
              const approved = has(action, 'approved_status')
              const rejected = has(action, 'rejected')
              const flow = has(action, 'flow_approve')
              const sealType = has(action, 'sealtypeRes')
              const sealStatus = has(action, 'seal_status')
              if (
                awaitingApprove &&
                createby &&
                approved &&
                rejected &&
                flow &&
                sealType &&
                sealStatus
              ) {
                const {
                  awaiting_approve,
                  create_by,
                  approved_status,
                  rejected,
                  flow_approve,
                  sealtypeRes,
                  seal_status,
                } = action

                const roleSystemadmin = find(roles, data => {
                  return data.id === rolesObj.systemadmin
                })
                const roleAdmin = find(roles, data => {
                  return data.id === rolesObj.admin
                })
                const roleApprover = find(roles, data => {
                  return data.id === rolesObj.approver
                })
                const rolePurchaser = find(roles, data => {
                  return data.id === rolesObj.purchaser
                })
                let arrayRoleAction = []
                if (roleApprover || roleAdmin || roleSystemadmin) {
                  if (roleSystemadmin) {
                    if (
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        !sealtypeRes) || // sealtypeRes === false
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleAdmin) {
                    if (
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        !sealtypeRes) || // sealtypeRes === false
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleApprover) {
                    if (
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        !sealtypeRes) || // sealtypeRes === false
                      (approved_status &&
                        rejected !== 'Rejected' &&
                        flow_approve &&
                        awaiting_approve === 'Awaiting Approve' &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                }
                const filterRule = filter(
                  arrayRoleAction,
                  value => value.resRule === true
                )
                if (filterRule.length !== 0) {
                  return true
                } else {
                  return false
                }
              }
            } else if (flowData.length !== 0) {
              ///Approv flow
              const awaitingApprove = has(action, 'awaiting_approve')
              const createby = has(action, 'create_by')
              const approved = has(action, 'approved_status')
              const rejected = has(action, 'rejected')
              const flow = has(action, 'flow_approve')
              const sealType = has(action, 'sealtypeRes')
              const sealStatus = has(action, 'seal_status')
              if (
                awaitingApprove &&
                createby &&
                approved &&
                rejected &&
                flow &&
                sealType &&
                sealStatus
              ) {
                const {
                  awaiting_approve,
                  create_by,
                  approved_status,
                  rejected,
                  flow_approve,
                  sealtypeRes,
                  seal_status,
                } = action

                const roleSystemadmin = find(roles, data => {
                  return data.id === rolesObj.systemadmin
                })
                const roleAdmin = find(roles, data => {
                  return data.id === rolesObj.admin
                })
                const roleApprover = find(roles, data => {
                  return data.id === rolesObj.approver
                })
                const rolePurchaser = find(roles, data => {
                  return data.id === rolesObj.purchaser
                })
                const roleObs = find(
                  roles,
                  value => value.id === rolesObj.observer
                )
                // awaiting_approve , rejected = rfq_award_status ที่ awaiting_approve = rejected ????
                //const status_rfq = awaiting_approve
                let arrayRoleAction = []
                if (
                  rolePurchaser ||
                  roleApprover ||
                  roleSystemadmin ||
                  roleAdmin ||
                  roleObs
                ) {
                  // roles observer
                  if (roleObs) {
                    if (
                      (awaiting_approve === 'Awaiting Selection' ||
                        awaiting_approve === 'Awaiting Approve' ||
                        rejected === 'Rejected' ||
                        awaiting_approve === 'Awarded') &&
                      (!seal_status || seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (rolePurchaser) {
                    if (
                      // (status_rfq === 'Awaiting Selection' ||
                      //   status_rfq === 'Rejected' ||
                      //   status_rfq === 'Awaiting Approve' ||
                      //   status_rfq === 'Awarded') &&
                      // (!seal_status || seal_status === unsealed)

                      //sealtypeRes === false  ไม่รู้ว่าคือเช็คอะไร

                      (awaiting_approve === 'Awaiting Selection' &&
                        (!seal_status || seal_status === unsealed)) ||
                      (awaiting_approve === 'Awarded' &&
                        (!seal_status || seal_status === unsealed)) ||
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        !sealtypeRes) || // sealtypeRes === false
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleSystemadmin) {
                    if (
                      (awaiting_approve === 'Awaiting Selection' &&
                        (!seal_status || seal_status === unsealed)) ||
                      (awaiting_approve === 'Awarded' &&
                        (!seal_status || seal_status === unsealed)) ||
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        !sealtypeRes) || // sealtypeRes === false
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleAdmin) {
                    if (
                      (awaiting_approve === 'Awaiting Selection' &&
                        (!seal_status || seal_status === unsealed)) ||
                      (awaiting_approve === 'Awarded' &&
                        (!seal_status || seal_status === unsealed)) ||
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        !sealtypeRes) || // sealtypeRes === false
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                  if (roleApprover) {
                    if (
                      (awaiting_approve === 'Awarded' &&
                        (!seal_status || seal_status === unsealed)) ||
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        !sealtypeRes) || // sealtypeRes === false
                      ((rejected === 'Rejected' ||
                        awaiting_approve === 'Awaiting Approve') &&
                        seal_status === unsealed)
                    ) {
                      const rule = { resRule: true }
                      arrayRoleAction.push(rule)
                    }
                  }
                }
                const filterRule = filter(
                  arrayRoleAction,
                  value => value.resRule === true
                )
                if (filterRule.length !== 0) {
                  return true
                } else {
                  return false
                }
              }
            } else if (selections.length !== 0) {
              let arrayRoleAction = []
              const buyerId = localStorage.getItem('buyerId')
              const filterRolesTec = filter(
                roles,
                value => value.id === rolesObj.tec
              )
              const filterRolesObs = filter(
                roles,
                value => value.id === rolesObj.observer
              )
              const rolePurchaser = filter(roles, data => {
                return data.id === rolesObj.purchaser
              })

              const rolesApp = filter(roles, data => {
                return data.id === rolesObj.approver
              })

              const roleAdmin = filter(roles, data => {
                return data.id === rolesObj.admin
              })

              const systemadmin = filter(roles, data => {
                return data.id === rolesObj.systemadmin
              })

              ///for mutirole have purchaser
              if (
                (rolePurchaser.length !== 0 ||
                  roleAdmin.length !== 0 ||
                  systemadmin.length !== 0) &&
                buyerId === action.create_by
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonCopy.length !== 0) {
              let arrayRoleAction = []
              const roleSystemadmin = filter(roles, data => {
                return data.id === rolesObj.systemadmin
              })
              const roleAdmin = filter(roles, data => {
                return data.id === rolesObj.admin
              })
              const rolePurchaser = filter(roles, data => {
                return data.id === rolesObj.purchaser
              })
              const filterRolesTec = filter(
                roles,
                value => value.id === rolesObj.tec
              )
              const filterRolesObs = filter(
                roles,
                value => value.id === rolesObj.observer
              )
              const filterRolesApp = filter(
                roles,
                value => value.id === rolesObj.approver
              )
              // Disable roles Tec || Obs || App
              // if (
              //   filterRolesTec.length !== 0 ||
              //   filterRolesObs.length !== 0 ||
              //   filterRolesApp.length !== 0
              // ) {
              //   const rule = { resRule: false }
              //   arrayRoleAction.push(rule)
              // }
              // Allow roles Admin || SysAdmin || Purchaser
              if (
                roleSystemadmin.length !== 0 ||
                roleAdmin.length !== 0 ||
                rolePurchaser.length !== 0
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                // Disable roles Tec || Obs || App
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonExport.length !== 0) {
              let arrayRoleAction = []
              const filterSysAdmin = filter(
                roles,
                value => value.id === rolesObj.systemadmin
              )
              const filterRolesAdmin = filter(
                roles,
                value => value.id === rolesObj.admin
              )
              const filterRolesPurchaser = filter(
                roles,
                value => value.id === rolesObj.purchaser
              )
              const filterRolesApp = filter(
                roles,
                value => value.id === rolesObj.approver
              )
              if (
                filterSysAdmin.length !== 0 ||
                filterRolesAdmin.length !== 0 ||
                filterRolesPurchaser.length !== 0 ||
                filterRolesApp.length !== 0
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonSubmitAward.length !== 0) {
              let arrayRoleAction = []
              const buyerId = localStorage.getItem('buyerId')
              const filterSysAdmin = filter(
                roles,
                value => value.id === rolesObj.systemadmin
              )
              const filterRolesAdmin = filter(
                roles,
                value => value.id === rolesObj.admin
              )
              const filterRolesPurchaser = filter(
                roles,
                value => value.id === rolesObj.purchaser
              )
              const isCreate = buyerId === action.create_by ? true : false
              if (
                (filterSysAdmin.length !== 0 ||
                  filterRolesPurchaser.length !== 0 ||
                  filterRolesAdmin.length !== 0) &&
                isCreate
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonSavingTypeClear.length !== 0) {
              const sealType = has(action, 'sealtypeRes')
              const sealStatus = has(action, 'seal_status')
              let arrayRoleAction = []
              const filterSysAdmin = filter(
                roles,
                value => value.id === rolesObj.systemadmin
              )
              const filterRolesAdmin = filter(
                roles,
                value => value.id === rolesObj.admin
              )
              const filterRolesPurchaser = filter(
                roles,
                value => value.id === rolesObj.purchaser
              )
              const filterRolesApp = filter(
                roles,
                value => value.id === rolesObj.approver
              )
              const filterRolesObs = filter(
                roles,
                value => value.id === rolesObj.observer
              )
              if (
                filterSysAdmin.length !== 0 ||
                filterRolesAdmin.length !== 0 ||
                filterRolesPurchaser.length !== 0 ||
                filterRolesApp.length !== 0 ||
                filterRolesObs.length !== 0
              ) {
                if (sealType && sealStatus) {
                  const { sealtypeRes, seal_status } = action
                  if (!sealtypeRes || seal_status === unsealed) {
                    const rule = { resRule: true }
                    arrayRoleAction.push(rule)
                  } else {
                    const rule = { resRule: false }
                    arrayRoleAction.push(rule)
                  }
                } else {
                  const rule = { resRule: false }
                  arrayRoleAction.push(rule)
                }
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonNoSelection.length !== 0) {
              // show buttonNoSelection
              const buyerId = localStorage.getItem('buyerId')
              let arrayRoleAction = []
              const filterSysAdmin = filter(
                roles,
                value => value.id === rolesObj.systemadmin
              )
              const filterRolesAdmin = filter(
                roles,
                value => value.id === rolesObj.admin
              )
              const filterRolesPurchaser = filter(
                roles,
                value => value.id === rolesObj.purchaser
              )
              const isCreate = buyerId === action.create_by ? true : false

              if (
                (filterSysAdmin.length !== 0 ||
                  filterRolesPurchaser.length !== 0 ||
                  filterRolesAdmin.length !== 0) &&
                isCreate
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            } else if (buttonResubmitAward.length !== 0) {
              // show buttonResubmitAward
              const buyerId = localStorage.getItem('buyerId')
              let arrayRoleAction = []
              const filterSysAdmin = filter(
                roles,
                value => value.id === rolesObj.systemadmin
              )
              const filterRolesAdmin = filter(
                roles,
                value => value.id === rolesObj.admin
              )
              const filterRolesPurchaser = filter(
                roles,
                value => value.id === rolesObj.purchaser
              )

              const isCreate = buyerId === action.create_by ? true : false
              if (
                (filterSysAdmin.length !== 0 ||
                  filterRolesAdmin.length !== 0 ||
                  filterRolesPurchaser.length !== 0) &&
                isCreate
              ) {
                const rule = { resRule: true }
                arrayRoleAction.push(rule)
              } else {
                const rule = { resRule: false }
                arrayRoleAction.push(rule)
              }
              const filterRule = filter(
                arrayRoleAction,
                value => value.resRule === true
              )
              if (filterRule.length !== 0) {
                return true
              } else {
                return false
              }
            }
          }
        }
      }
    },
  }
}
